import { PublicSelectComponent } from '@componentes/public-select/public-select.component';
import { Select } from '@layout/interfaces/select';

interface StringEnum {
  [chave: string]: string;
}

export interface StringEnumWithLabel {
  enum: StringEnum,
  getLabel: (v: string) => string
}

export abstract class PublicSelectEnumComponent extends PublicSelectComponent<
  Select,
  string
> {
  protected constructor(
    enumType: StringEnum | [string, StringEnumWithLabel][],
    getLabel: (v: string) => string = v => v
  ) {
    super();

    if (Array.isArray(enumType)) {
      this.options = enumType.reduce((acc, [v, et]) => ({
        ...acc,
        [v]: Object.keys(et.enum).map(k => ({
          value: et.enum[k],
          name: et.getLabel(et.enum[k]),
        }))
      }), {});
    } else {
      this.options = Object.keys(enumType).map(k => ({
        value: enumType[k],
        name: getLabel(enumType[k]),
      }));
    }

    this.optionValue = 'value';
    this.optionLabel = 'name';
  }
}
